import React, { useContext, useEffect } from 'react';

import { isEmpty } from 'ramda';

import { EPageRole } from '../../../LandingV2/Page/types';
import { PDFDataContext } from '../../context';
import { TravelBriefTable } from './TravelBriefTable';
import { AccommodationTable } from './TravelBriefTable/AccommodationTable';
import { FlightTable } from './TravelBriefTable/FlightTable';

export const TravelBriefPage = ({ onReady }) => {
  const { page } = useContext(PDFDataContext);
  const pageLanding = page.landing.pages.find((p) =>
    [EPageRole.TRAVEL_BRIEF, EPageRole.SAFARI_OVERVIEW].includes(p.role),
  );
  const showCondition =
    !pageLanding || pageLanding.hidden || isEmpty(page.tripEvents) || isEmpty(page.travelBrief.overall);

  useEffect(() => {
    if (showCondition) {
      onReady();
    }
  }, [onReady, showCondition]);

  if (showCondition) {
    return null;
  }

  return (
    <>
      <TravelBriefTable onReady={onReady} />
      <FlightTable />
      <AccommodationTable />
    </>
  );
};
